import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import {getMessage as msg} from 'MessageBundle';

import theme from './BasketList.scss';

/**
 * Shows list of the baskets at the left side of VPQuick Client.
 * A basket in the list represented as its short name and number of the complaints inside.
 */
const cx = classnames.bind(theme);
export default class BasketList extends React.Component {

    render() {
        return (
            <aside>
                <h2>{msg('basketList.header')}</h2>
                <ul>
                    {this.props.value.map((item, idx) => (
                        <li key={idx}>
                            <a href="#" onClick={() => this.props.onSelect(item)} className={cx({
                                basketNotProcessed: item.notProcessed,
                                basketSelected: item === this.props.selectedBasket
                            })}>
                                {item.name + ' (' + item.numberOfIssues + ')'}
                                {item === this.props.selectedBasket ? <span class="sr-only"> {msg('basketList.selectedBasket')}</span> : ""}
                            </a>
                        </li>
                    ))}
                </ul>
            </aside>
        );
    }
};

BasketList.propTypes = {
    /**
     * List of the basket to be shown.
     */
    value: PropTypes.array.isRequired,

    /**
     * The selected basket to mark.
     */
    selectedBasket: PropTypes.object.isRequired,

    /**
     * JavaScript function that has to be executed on basket select.
     */
    onSelect: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/Start/BasketList/index.js